import { updatedMedia } from 'client/styles'
import styled from 'styled-components'
import { Paragraph } from 'src/styles/typography/typography'

export const FooterButton = styled.div`
  padding-block: 20px;
  padding-inline: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  transition: all 0.2s;

  svg {
    fill: ${({ theme }) => theme.colors.grey3};
  }

  ${updatedMedia.onlyMobile} {
    button {
      width: 100%;
    }
  }
`

export const PropertyInfo = styled.div`
  display: none;
  ${updatedMedia.tablet} {
    display: flex;
    align-items: center;
  }
`

export const PropertyTitle = styled(Paragraph)`
  font-weight: 700;
  margin-inline-end: 10px;
`
